<template lang="pug">
  .table-responsive
    table#tbAceptarItems.table.is-striped.is-fullwidth
      thead
        tr
          th Categoría(s)
          th Descripción
          th Observación
      tbody
        tr(v-for="(data, index) in items" :key="data.id")
          td  
            span(v-html="getCats(data)")
          td 
            p.is-size-6
              b Serie: &nbsp
              | {{ data.serie }}
            p.is-size-6
              .control
                .tags.has-addons
                  span.tag.is-dark
                    | {{ data.marca }}
                  span.tag.is-light
                    | {{ data.modelo}}
          td
            .field
              .control
                input.input.is-dark(
                  type='text', 
                  :placeholder="baja.estado >= 2 ? data.observacion : ''",
                  @keyup.enter="saveObservaciones($event, data)",
                  :disabled="isDisabled"
                  :value="data.observacion"
                )
                a.button.is-warning.is-small.is-rounded(
                  @click="editarObservacion()" 
                  v-show='!isEditing'
                )
                  i.fas.fa-pen
                a.button.is-danger.is-small.is-rounded(
                  @click="eliminarObservacion(data)" 
                  v-show='!isEditing'
                ) 
                  i.fas.fa-trash
                a.button.is-dark.is-small.is-rounded(
                  @click="cancelarObservacion()" 
                  v-show='isEditing'
                )
                  i.fas.fa-times
</template>

<script>
  export default {
    name: 'TbAceptarItemsAsignacion',
    props: {
      items: {
        type: Array,
        default: []
      },
      baja: {
        type: Object,
        default: ()=> {}
      }
    },
    data() {
      return {
        isEditing: false,
        observacion: '',
        isDisabled: true,
      }
    },
    watch: {
      baja() {
        if (this.data) {
          console.log(this.data)
          this.observacion = this.data.observacion
        }
      }
    },
    methods: {
      getCats(data) {
        let htmlStr = ''
        if (data.subcategoria === '') {
          htmlStr = `<span class="tag is-warning">${data.categoria}</span>`
        } else {
          htmlStr = `<div class="control">
            <div class="tags has-addons">
              <span class="tag is-black">
                <i class="fas fa-tag"></i>&nbsp ${data.categoria}
              </span>
              <span class="tag is-warning"> ${data.subcategoria}
              </span>
            </div>
          </div>`
        }
        return htmlStr
      },
      handleChange(e, data) {
        if (e.target.checked) {
          this.$emit('aceptarItem', data)
        } else {
          console.log(e.target.checked)
          this.$emit('rechazarItem', data)
        }
      },
      saveObservaciones(e, data) {
        const descripcion = data.subcategoria !== '' ? `${data.categoria} ${data.subcategoria}` : data.categoria
        let myObj = {
          id_articulo: data.id,
          observacion: e.target.value,
          descripcion
        }
        this.isEditing = false
        this.isDisabled = true
        this.$emit('saveObservacion', myObj)
      },
      editarObservacion () {
        this.isEditing = true
        this.isDisabled = false
      },
      eliminarObservacion (data) {
        const descripcion = data.subcategoria !== '' ? `${data.categoria} ${data.subcategoria}` : data.categoria
        let myObj = {
          id_articulo: data.id,
          descripcion
        }
        this.$emit('deleteObservacion', myObj)
        this.isDisabled = true
      },
      cancelarObservacion () {
        this.isEditing = false
        this.isDisabled = true
      },
      getEstadoObs () {
        switch (this.baja.estado) {
          case 2:
            this.isDisabled = true
            return true
          case 3:
            return false
        }
      }
    },
    created () {
      if (this.data) {
        console.log(this.data)
        this.observacion = this.data.observacion
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/TbAceptarItemsBaja.vue